import { useCallback, useEffect, useState } from 'react';

export const useIsOverflowing = <T extends HTMLElement = HTMLElement>(
  dependency: string,
) => {
  const [element, setElement] = useState<T | null>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const ref = useCallback((node: T | null) => {
    setElement(node);
  }, []);

  useEffect(() => {
    if (!element) {
      return;
    }

    const measure = () => {
      const lineHeight = parseFloat(getComputedStyle(element).lineHeight);

      if (Number.isNaN(lineHeight) || lineHeight <= 0) {
        setIsOverflowing(element.scrollHeight > element.clientHeight);
        return;
      }

      const contentLines = Math.round(element.scrollHeight / lineHeight);
      const visibleLines = Math.round(element.clientHeight / lineHeight);

      setIsOverflowing(contentLines > visibleLines);
    };

    measure();

    const observer = new ResizeObserver(measure);

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [element, dependency]);

  return { isOverflowing, ref };
};
